export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Início',
        to: '/home',
        icon: 'cil-speedometer'
      },
      {
        _name:'CSidebarNavItem',
        name: 'Formulários',
        to: '/checklist',
        icon: 'cil-task'
      },
      {
        _name:'CSidebarNavItem',
        name: 'Ajuda',
        to: '/ajuda',
        icon: 'cil-comment-square'
      }
    ]
  }
]
